let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iLpR8")).then(() => parcelRequire('7GeK2'));